/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { c as chooseImage } from '../../../index-0bcce539.js';
import '../../../index-892d8eee.js';
import '../../../_commonjsHelpers-56d33373.js';

var mini = chooseImage;

export { mini as default };
